import React, { PureComponent } from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import Asset from "../../requests/apa/Asset";
import Device from "../../devices/device"
import './styles/AAFModalQrPayments.scss';
import Utils from '../../utils/Utils';
import { linkSessions } from '../../payments/Checkout/utils';
import { SUCCESFULL, EXPIRED, DELETE, GET } from '../../payments/utils/constants';
import { HIDE_MODAL } from '../../actions/modal';
import store from '../../store';

class AAFModalQrPayments extends PureComponent {
    // AOSPCL-614: no toma el valor de inactivity_timeout_seconds de qr_flow_config.
    // `Number(x) || 300` trata un 0 configurado (timeout deshabilitado, como ya se usa
    // en QR_ACTIVATION_CONFIG_HBO_DEFAULT) como si faltara la llave, y el piso fijo de
    // 180s ignoraba silenciosamente cualquier valor regional menor a ese piso.
    static resolveInactivityTimeoutSeconds(inactivityTimeoutSeconds) {
        const configuredTimeout = Number(inactivityTimeoutSeconds);
        return Number.isFinite(configuredTimeout) && configuredTimeout >= 0
            ? configuredTimeout
            : 300;
    }

    constructor(props) {
        super(props);
        const { code, qrCode  } = this.props.response || {};
        this.code = code || '';

        this.screenType = this.props.qrFlowConfig.tag;
        const rawTimeout = AAFModalQrPayments.resolveInactivityTimeoutSeconds(
            this.props.qrFlowConfig.inactivity_timeout_seconds
        );
        this.inactivityTimeoutSeconds = rawTimeout * 1000;
        this.icon = Asset.get('mdp_logo_clarovideo');
        this.title =  Utils.cutPlayerString(Translator.get(`mdp_qrmdp_texto_titulo_${this.screenType}`), 45);
        this.option1 = Utils.cutPlayerString(Translator.get(`mdp_qrmdp_opcion1_texto_titulo_${this.screenType}`), 32);
        this.option1Step1 = Utils.cutPlayerString(Translator.get(`mdp_qrmdp_opcion1_texto_parrafo_paso1_${this.screenType}`), 80);
        this.option1Step2 = Utils.cutPlayerString(Translator.get(`mdp_qrmdp_opcion1_texto_parrafo_paso2_${this.screenType}`), 80);
        this.option2 = Utils.cutPlayerString(Translator.get(`mdp_qrmdp_opcion2_texto_titulo_${this.screenType}`), 32);
        this.option2Step1 = Utils.cutPlayerString(Translator.get(`mdp_qrmdp_opcion2_texto_parrafo_paso1_${this.screenType}`), 80);
        this.option2Step1Link = Utils.cutPlayerString(Translator.get(`mdp_qrmdp_opcion2_enlace_texto_${this.screenType}`), 30);
        this.option2Step2 = Utils.cutPlayerString(Translator.get(`mdp_qrmdp_opcion2_texto_parrafo_paso2_${this.screenType}`), 80);
        this.option2Step3 = Utils.cutPlayerString(Translator.get(`mdp_qrmdp_opcion2_texto_parrafo_paso3_${this.screenType}`), 80);
        this.number1 = Translator.get('mdp_texto_digito_paso1');
        this.number2 = Translator.get('mdp_texto_digito_paso2');
        this.number3 = Translator.get('mdp_texto_digito_paso3');

        this.formattedCode = Utils.cutPlayerString(this.formatByThree(code), 9);
        this.qrImage = qrCode;
        this.timeInMiliseconds =  this.props.pullingDurationSeconds * 1000;
        this.qrRetries = this.props.qrRetries;

        this.pollTimeout = null;
        this.inactivityTimeout = null;
        this.polling = false;
        this.isComponentMounted = false;
        this.shouldDeleteSessionOnUnmount = true;

        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.keys = Device.getDevice().getKeys();
    }

    componentDidMount() {
        if (document && document.addEventListener) {
            document.addEventListener('keydown', this.handleKeyPress, true);
        }
        this.isComponentMounted = true;
        this.startInactivityTimeout();
        this.startPolling();
    }

    componentWillUnmount() {
        if (document && document.removeEventListener) {
            document.removeEventListener('keydown', this.handleKeyPress, true);
        }
        this.isComponentMounted = false;
        this.clearInactivityTimeout();
        this.stopPolling();

        if (this.shouldDeleteSessionOnUnmount && this.code) {
            this.statusCode(DELETE, this.code, this.qrRetries).catch((error) => console.error('Error al cancelar sesión QR:', error));
        }
    }

    closeModal = (e) => {
        this.clearInactivityTimeout();
        this.stopPolling();
        const dispatcher = (this.props && this.props.dispatch) || (store && store.dispatch);
        if (dispatcher && typeof dispatcher === 'function') {
            dispatcher({ type: HIDE_MODAL });
        }
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
    }

    notifyStatus = (status) => {
        const { onStatusChange } = this.props;
        if (typeof onStatusChange === 'function') {
            onStatusChange(status);
        }
    }

    startInactivityTimeout = () => {
        this.clearInactivityTimeout();
        const rawTimeout = AAFModalQrPayments.resolveInactivityTimeoutSeconds(
            this.props.qrFlowConfig.inactivity_timeout_seconds
        );
        this.inactivityTimeoutSeconds = rawTimeout * 1000;
        if (!rawTimeout || rawTimeout <= 0) return;

        this.inactivityTimeout = setTimeout(() => {
            this.closeModal();
        }, this.inactivityTimeoutSeconds);
    };

    clearInactivityTimeout = () => {
        if (this.inactivityTimeout) {
            clearTimeout(this.inactivityTimeout);
            this.inactivityTimeout = null;
        }
    };

    async handleKeyPress(e) {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        switch (currentKey) {
            case 'BACK':
                this.statusCode(DELETE, this.code, this.qrRetries).catch((error) => console.error('Error al cancelar sesión QR:', error));
                this.closeModal(e);
            break;
            default:
        }
    }

    startPolling = () => {
        if (this.polling) return;
        this.polling = true;
        this.pollApi(); 
    };

    stopPolling = () => {
        this.polling = false;
        if (this.pollTimeout) {
            clearTimeout(this.pollTimeout);
            this.pollTimeout = null;
        }
    };

    pollApi = async () => {
        if (!this.isComponentMounted || !this.polling) return;

        let result = null;
        try {
            result = await this.statusCode(GET, this.code, this.qrRetries);
        } catch (error) {
            console.log("Error polling API:", error);
            this.stopPolling();
            this.shouldDeleteSessionOnUnmount = false;
            this.closeModal();
            return;
        }
        if (!this.isComponentMounted || !this.polling) return;
        if (result && result.data && result.data.status === SUCCESFULL) {
            this.stopPolling();
            this.shouldDeleteSessionOnUnmount = false;
            this.notifyStatus(SUCCESFULL);
            this.closeModal();
        } else if (result && result.data && result.data.status === EXPIRED) {
            this.stopPolling();
            this.shouldDeleteSessionOnUnmount = false;
            this.closeModal();
        } else {
            this.scheduleNextPoll();
        }
    };

    scheduleNextPoll = () => {
        if (!this.isComponentMounted || !this.polling) return;
        this.pollTimeout = setTimeout(this.pollApi, this.timeInMiliseconds);
    };

    statusCode = async (type, code, retries) => {
        return await linkSessions(null, type, code, retries);
    };

    formatByThree = (code = '') => {
	    if (typeof code !== 'string') return '';
	    return code.match(/.{1,3}/g) && code.match(/.{1,3}/g).join(' - ') || '';
    };

    render() {
        return (
            <ModalWrapper>
                <div className='screen-payments-qr'>
                    <div className="payments-qr_icon_header">
                        <img src={this.icon} alt="logo header" />
                    </div>
                    <div className="payments-qr_info_container">
                        <h1 className="payments-qr_title">{this.title}</h1>
                        <div className="payments-qr_content"> 
                            <div className="payments-qr_column_left">
                                <div className="payments-qr_option_container">
                                    <p className="payments-qr_option_text">
                                        {this.option1}
                                    </p>
                                </div>
                                <div className="payments-qr_step_container">
                                    <div className="payments-qr_step_number">
                                        {this.number1}
                                    </div>
                                    <div className="payments-qr_step_info">
                                        <p className="payments-qr_step_info_text">
                                            {this.option1Step1}
                                        </p>
                                        <div  className="payments-qr_step_info_image">
                                            <img src={this.qrImage} alt="QR"/>
                                        </div>
                                    </div>
                                </div>
                                <div className="payments-qr_step_container last_step">
                                    <div className="payments-qr_step_number">
                                        {this.number2}
                                    </div>
                                    <div className="payments-qr_step_info">
                                        <p className="payments-qr_step_info_text">
                                            {this.option1Step2}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="payments-qr_column_right">
                            <div className="payments-qr_option_container">
                                    <p className="payments-qr_option_text">
                                        {this.option2}
                                    </p>
                                </div>
                                <div className="payments-qr_step_container">
                                    <div className="payments-qr_step_number">
                                        {this.number1}
                                    </div>
                                    <div className="payments-qr_step_info">
                                        <p className="payments-qr_step_info_text">
                                            {this.option2Step1}
                                        </p>
                                        <p className="payments-qr_step_info_link">
                                            {this.option2Step1Link}
                                        </p>
                                    </div>
                                </div>
                                <div className="payments-qr_step_container">
                                    <div className="payments-qr_step_number">
                                        {this.number2}
                                    </div>
                                    <div className="payments-qr_step_info">
                                        <p className="payments-qr_step_info_text">
                                            {this.option2Step2}
                                        </p>
                                        <p className="payments-qr_step_info_code">
                                            {this.formattedCode}
                                        </p>
                                    </div>
                                </div>
                                <div className="payments-qr_step_container last_step">
                                    <div className="payments-qr_step_number">
                                        {this.number3}
                                    </div>
                                    <div className="payments-qr_step_info">
                                        <p className="payments-qr_step_info_text">
                                            {this.option2Step3}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ModalWrapper>
        );
    }
}

export default withOnClose(AAFModalQrPayments);


// WEBPACK FOOTER //
// ./src/components/Modal/AAFModalQrPayments.jsx